import { IEnvironment } from "@data/environment/environment.interface";

export const defaultEnv: IEnvironment = {
    api: 'https://api.leadadvantagepro.com/api/',
    authClient: 'https://authorize.leadadvantagepro.com/',
    authCookie: 'LASelfService',
    transitionCookie: 'LAAuth2SelfService',
    isProduction: true,
}